module.exports = __webpack_public_path__ + "static/media/MuliRegular.85f158dc.woff";